export const CategoryTableCellName = {
  Buildings: 'buildings',
  CategoryGroups: 'category_groups',
  Name: 'name',
}
